module.exports = __webpack_public_path__ + "img/02-min.4f0d15d7.jpg";